import React from "react";
import { Table, Button, Confirm, Popup } from "semantic-ui-react";

const botones = [
  {
    key: 0,
    texto: "Cita Realizada",
    icono: "check",
    accion: "completar"
  },
  {
    key: 1,
    texto: "Modificar Cita",
    icono: "pencil",
    accion: "modificar"
  },
  {
    key: 2,
    texto: "Eliminar Cita",
    icono: "trash",
    accion: "borrar"
  }
];

class FilaCitas extends React.Component {
  state = {
    style: {},
    verConfirm: false,
    showButtons: false
  };

  /*- Mouse Events -*/
  onMouseEnter = () =>
    this.setState({
      style: { backgroundColor: "lavenderblush" },
      showButtons: true
    });

  onMouseLeave = () => this.setState({ style: {}, showButtons: false });

  /*- Handlers -*/
  handleEditar = () => this.props.handleEditItem(this.props.datos.id);

  handleBorrar = () => this.setState({ verConfirm: true });

  handleBorrarCancela = () => this.setState({ verConfirm: false });

  handleBorrarConfirma = () => {
    this.setState({ verConfirm: false });
    this.props.handleBorrarItem(this.props.datos.id);
  };

  handleCompletar = () => this.props.handleCompletarTarea(this.props.datos.id);

  /*- Render Helpers -*/
  renderFechaCreacion = () =>
    `${new Date(this.props.datos.timestamp).toLocaleDateString()}`;

  renderFechaLimite = () =>
    `${new Date(this.props.datos.fecha_cita).toLocaleDateString()}`;

  renderActionButtons = botones.map(boton => (
    <Popup
      key={boton.key}
      content={boton.texto}
      trigger={
        <Button
          disabled={this.props.datos.completada}
          basic
          icon={boton.icono}
          circular
          onClick={
            boton.accion === "completar"
              ? this.handleCompletar
              : boton.accion === "modificar"
                ? this.handleEditar
                : this.handleBorrar
          }
        />
      }
    />
  ));

  render() {
    const { completada } = this.props.datos;
    return (
      <React.Fragment>
        <Table.Row
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
          positive={completada}
        >
          <Table.Cell content={this.renderFechaCreacion()} collapsing />
          <Table.Cell content={this.renderFechaLimite()} collapsing />
          <Table.Cell content={this.props.datos.descripcion} />
          <Table.Cell collapsing>{this.renderActionButtons}</Table.Cell>
        </Table.Row>

        <Confirm
          open={this.state.verConfirm}
          onCancel={this.handleBorrarCancela}
          onConfirm={this.handleBorrarConfirma}
          header="Se va a eliminar la tarea"
          content="¿Desea continuar?"
          cancelButton="No"
          confirmButton="si"
        />
      </React.Fragment>
    );
  }
}

export default FilaCitas;



// WEBPACK FOOTER //
// ./src/pages/ventas/ventasNuevaCita/tablaCitas/FilaCitas.jsx